import { render, staticRenderFns } from "./DashboardJobList.vue?vue&type=template&id=445a9763&"
import script from "./DashboardJobList.vue?vue&type=script&lang=js&"
export * from "./DashboardJobList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports